<template lang="pug">
  validation-observer(ref="inquiryForm")
    form.inquiry-form(@submit.prevent="onSubmit")
      h3 Customer Information
      .row
        .col-sm-6
          validation-provider(
            v-slot="{ errors, valid }"
            rules="required"
            name="Name English"
          )
            .form-group
              label(for="nameEnglish") Name English *
              input#nameEnglish.form-control(
                v-model="fields.name_english"
                type="text"
                :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
              )
              span.invalid-feedback {{ errors[0] }}

        .col-sm-6
          .form-group
            label(for="nameChinese") Name Chinese (if any)
            input#nameChinese.form-control(
              v-model="fields.name_chinese"
              type="text"
            )

      .row
        .col-sm-6
          validation-provider(
            v-slot="{ errors, valid }"
            rules="required"
            name="Email"
          )
            .form-group
              label(for="email") Email *
              input#email.form-control(
                v-model="fields.email"
                type="email"
                :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
              )
              span.invalid-feedback {{ errors[0] }}

        .col-sm-6
          .form-group
            label(for="officialWebsite") Official website URL
            input#officialWebsite.form-control(
              v-model="fields.website"
              type="text"
            )

      .row
        .col-sm-6
          validation-provider(
            v-slot="{ errors, valid }"
            rules="required"
            name="Business Type"
          )
            .form-group
              label(for="businessType") Business Type *
              select.form-control(
                v-model="fields.business_type"
                :class="{ 'is-invalid': errors[0], 'is-valid': valid }"
              )
                option(value="" disabled selected) Select Business Type
                option(value="Paper Merchant") Paper Merchant
                option(value="Industry factory") Industry factory
                option(value="Converter") Converter
                option(value="End user") End user
                option(value="Brand owner") Brand owner
                option(value="Other") Other
              span.invalid-feedback {{ errors[0] }}
    
        .col-sm-6
          .form-group
            label(for="converterName") Converter name (if merchant)
            input#converterName.form-control(
              v-model="fields.converter_name"
              type="text"
            )

      .row
        .col-sm-6
          .form-group
            label(for="countryLocated") Country located
            input#countryLocated.form-control(
              v-model="fields.country_located"
              type="text"
            )

        .col-sm-6
          .form-group
            label(for="portDischarge") Port of discharge
            input#portDischarge.form-control(
              v-model="fields.port_discharge"
              type="text"
            )

      .row
        .col-sm-6
          .form-group
            label(for="mgPaperConsumption") MG paper consumption
            input#mgPaperConsumption.form-control(
              v-model="fields.mg_paper_consumption"
              type="text"
            )
        .col-sm-6
          .form-group
            label(for="application") Application
            input#application.form-control(
              v-model="fields.application"
              type="text"
            )

      .row
        .col-sm-4
          .form-group
            label(for="peLamination") PE lamination
            input#peLamination.form-control(
              v-model="fields.pe_lamination"
              type="text"
            )

        .col-sm-4
          .form-group
            label(for="aluminumLamination") Aluminum lamination
            input#aluminumLamination.form-control(
              v-model="fields.aluminum_lamination"
              type="text"
            )

        .col-sm-4
          .form-group
            label(for="printing") Printing
            input#printing.form-control(
              v-model="fields.printing"
              type="text"
            )

      .form-group
        label(for="endUsername") End user name
        input#endUsername.form-control(
          v-model="fields.end_username"
          type="text"
        )


      h3 Request Specification

      .row
        .col-sm-6
          .form-group
            label(for="substance") Substance
            .input-group
              input#substance.form-control(
                v-model="fields.substance"
                type="number"
              )
              .input-group-append
                .input-group-text gsm
        .col-sm-6
          .form-group
            label(for="width") Width
            .input-group
              input#width.form-control(
                v-model="fields.width"
                type="number"
              )
              .input-group-append
                .input-group-text mm


      .row
        .col-sm-6
          .form-group
            label(for="coreSize") Core size
            .input-group
              input#coreSize.form-control(
                v-model="fields.core_size"
                type="number"
              )
              .input-group-append
                .input-group-text mm
        .col-sm-6
          .form-group
            label(for="coreCap") Core cap
            input#coreCap.form-control(
              v-model="fields.core_cap"
              type="text"
            )

      .form-group
        label(for="specialRequest") Special request for paper properties
        .input-group
          input#specialRequest.form-control(
            v-model="fields.special_request"
            type="number"
          )
          .input-group-append
            .input-group-text gsm

      .form-group.mb-5
        .custom-control.custom-checkbox.mb-5
          input#requestCertificate.custom-control-input(
            type="checkbox"
            v-model="fields.request_certificate"
          )
          label.custom-control-label(for="requestCertificate") Request for certificate


      h3 Current Supplier Information

      .current-supplier-item(
        v-for="(item, index) in fields.current"
        :key="index"
      )
        .current-supplier-item-title.d-flex.justify-content-between.align-items-center
          span
            strong {{ index + 1 }}.
            strong(v-if="item.supplier_name")  {{ item.supplier_name }} 
          
          button.btn.btn-primary.btn-sm(
            v-if="fields.current.length > 1"
            type="button"
            @click="remove($event, index)"
          ) Delete

        //- validation-provider(
        //-   v-slot="{ errors, valid }"
        //-   rules="required"
        //-   name="Supplier name (English)"
        //- )
        .form-group
          label(:for="`supplierName-${index}`") Supplier name (English)
          input.form-control(
            :id="`supplierName-${index}`"
            type="text"
            v-model="item.supplier_name"
          )
          //- span.invalid-feedback {{ errors[0] }}
            
        .row
          .col-sm-4
            .form-group
              label(:for="`name-${index}`") Substance
              .input-group
                input.form-control(
                  :id="`name-${index}`"
                  type="number"
                  v-model="item.substance"
                )
                .input-group-append
                  .input-group-text gsm

          .col-sm-4
            .form-group
              label(:for="`qty-${index}`") qty
              input.form-control(
                :id="`qty-${index}`"
                type="number"
                v-model="item.qty"
              )

          .col-sm-4
            .form-group
              label(:for="`price-${index}`") Price [MT CIF]
              .input-group
                input.form-control(
                  :id="`price-${index}`"
                  type="text"
                  v-model="item.price"
                )
                .input-group-append
                  .input-group-text USD
                  
        .form-group
          label(:for="`leadTime-${index}`") Lead time after PO issue
          input.form-control(
            :id="`leadTime-${index}`"
            type="text"
            v-model="item.lead_time"
          )

        .form-group
          label(:for="`quality-${index}`") Any quality issue
          input.form-control(
            :id="`quality-${index}`"
            type="text"
            v-model="item.quality"
          )

        .form-group
          label(:for="`allocation-${index}`") Any allocation issue
          input.form-control(
            :id="`allocation-${index}`"
            type="text"
            v-model="item.allocation"
          )

        .form-group
          label(:for="`delivery-${index}`") Any delivery issue
          input.form-control(
            :id="`delivery-${index}`"
            type="text"
            v-model="item.delivery"
          )


        .form-group
          label(:for="`claim-${index}`") Any claim handling issue
          input.form-control(
            :id="`claim-${index}`"
            type="text"
            v-model="item.claim"
          )

        .form-group
          label(:for="`other-${index}`") Any other problem
          input.form-control(
            :id="`other-${index}`"
            type="text"
            v-model="item.other"
          )

        .row
          .col-sm-6
            .form-group
              label(:for="`sheetSample-${index}`") Sheet sample
              .custom-file
                input.custom-file-input(
                  :id="`sheetSample-${index}`"
                  type="file"
                  @change="handleFileUpload($event, index, 'sheet_sample')"
                )
                label.custom-file-label(:for="`sheetSample-${index}`")
                  span(v-if="item.sheet_sample") {{ item.sheet_sample.name }}
                  span(v-else) Choose file...
          .col-sm-6
            .form-group
              label(:for="`specSheet-${index}`") Spec sheet
              .custom-file
                input.custom-file-input(
                  :id="`specSheet-${index}`"
                  type="file"
                  @change="handleFileUpload($event, index, 'spec_sheet')"
                  :ref="`specSheet-${index}`"
                )
                label.custom-file-label(:for="`specSheet-${index}`")
                  span(v-if="item.spec_sheet") {{ item.spec_sheet.name }}
                  span(v-else) Choose file...


      button.btn.btn-primary.mb-2(
        type="button"
        @click="generate"
      ) Add supplier

      h3.mt-4
        label(for="otherRemarks") Other Remarks
      .form-group.textarea
        textarea#otherRemarks.form-control(
          v-model="fields.other_remarks"
          rows="5"
        )

      validation-provider(
        v-slot="{ errors, valid }"
        rules="required"
        name="Accept"
      )
        .custom-control.custom-checkbox.mb-5
          input#privacy.custom-control-input(
            type="checkbox"
            v-model="fields.privacy"
            :class="{ 'is-invalid': errors[0] }"
          )
          label.custom-control-label(for="privacy") Yes, I have read and accept the 
            a(:href="`https://www.scgpackaging.com/${lang}/privacy-notice`" target="_blank")  Privacy Policy
          span.invalid-feedback {{ errors[0] }}

      p.text-right
        button.btn.btn-primary.pl-4.pr-4(
          type="submit"
          :disabled="buttonLoading || isLoading || !fields.privacy"
        )
          span.spinner-border.spinner-border-sm(
            v-if="buttonLoading"
            role="status"
            aria-hidden="true"
          )
          //- span Loading..
          |  Submit
</template>

<script>
import MoveTo from 'moveTo'
import { Confirm } from 'notiflix'
import { Report } from 'notiflix'
import axios from 'axios'

Report.Init({
  fontFamily: 'Prompt',
  svgSize: '40px',
  borderRadius: '5px',
})

export default {
  data: () => ({
    buttonLoading: false,
    isLoading: false,
    fields: {},
    lang: SNP.lang,
  }),

  created() {
    this.resetForm()
  },

  methods: {
    resetForm() {
      this.fields = {
        business_type: '',
        current: [{
          supplier_name: '',
          substance: '',
          qty: '',
          price: '',
          lead_time: '',
          quality: '',
          allocation: '',
          delivery: '',
          claim: '',
          other: '',
          sheet_sample: null,
          spec_sheet: null,
        }]
      }
    },
    
    handleFileUpload(event, index, field){
      const file = event.target.files[0]
      const formData = new FormData()
      formData.append('file', file)


      if (field === 'spec_sheet') {
        this.fields.current[index].spec_sheet = { name: 'loading...' }
      } else {
        this.fields.current[index].sheet_sample = { name: 'loading...' }
      }

      this.isLoading = true

      axios.post(`${SNP.api_endpoint}v1/inquiry/uploadfile`, formData)
        .then(({ data }) => {
          console.log(data)
          if (field === 'spec_sheet') {
            this.fields.current[index].spec_sheet = file
            this.fields.current[index].spec_sheet.id = data.id
          } else {
            this.fields.current[index].sheet_sample = file
            this.fields.current[index].sheet_sample.id = data.id
          }
        })
        .catch((error) => {
          Report.Failure(
            'Failure',
            error.response.data.message,
            'OK'
          )
          if (field === 'spec_sheet') {
            this.fields.current[index].spec_sheet = null
          } else {
            this.fields.current[index].sheet_sample = null
          }
        })
        .then(() => {
          this.isLoading = false
        })
    },

    onSubmit() {
      this.buttonLoading = true
      const form = this.$refs.inquiryForm
      form.validate().then(success => {
        if (!success) {
          setTimeout(() => {
            const errors = Object.entries(form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length);
              
            const to = form.refs[errors[0]['key']].$el
            const moveTo = new MoveTo({
              tolerance: 90,
              duration: 800,
            })

            moveTo.move(to)
            this.buttonLoading = false
          }, 100)
          return;
        } else {
          Confirm.Init({
            width: '350px',
            fontFamily: 'Prompt',
            borderRadius: '5px',
            titleColor: '#d82c2c',
            okButtonBackground: '#d82c2c',
            messageMaxLength: 10000,
            plainText: false,
          })

          const message = `${SNP.icon.checkmark} We have received your message and would like to thank you for writing to us. <br> We will contact you shortly.`

          axios
            .post(`${SNP.api_endpoint}v1/inquiry`, this.fields)
            .then(({ status }) => {
              Confirm.Show('Thanks for being awesome!', message, 'Ok')
              requestAnimationFrame(() => {
                this.resetForm()
                form.reset()
              })
            })
            .catch(error => {
              Report.Failure(
                'Failure',
                error.response.data.message,
                'OK'
              )
            })
            .then(() =>{
              this.buttonLoading = false
            })
        }
      });
      // try {
      // } catch (error) {
      //   const errors = error.response.data.errors
      //   form.setErrors(errors)
      // } finally {
      // }
    },

    generate(){
      this.fields.current.push({
        supplier_name: '',
        substance: '',
        qty: '',
        price: '',
        lead_time: '',
        quality: '',
        allocation: '',
        delivery: '',
        claim: '',
        other: '',
        sheet_sample: null,
        spec_sheet: null,
      })
    },

    remove(e, index){
      this.$delete(this.fields.current, index)
      // e.target.parentNode.parentNode.parentNode.removeChild(e.target.parentNode.parentNode)
    },
  },
}
</script>

